import { createContext, useContext, useState } from 'react';
type TabType = 'snipe' | 'positions' | 'moods';
interface SnipeContextInterface {
  activeTab: TabType;
  setActiveTab: (value: TabType) => void;
  amount: number;
  setAmount: (value: number) => void;
  assetInfo: any;
  setAssetInfo: (value: any) => void;
  contractAddress: string;
  setContractAddress: (value: string) => void;
  config: {
    gas: number;
    slippage: number;
  };
  setConfig: (value: {
    gas: number;
    slippage: number;
  }) => void;
}
const SnipeContext = createContext({} as SnipeContextInterface);
export const SnipeProvider = ({
  children
}: {
  children: React.ReactNode;
}) => {
  const [activeTab, setActiveTab] = useState<TabType>('snipe');
  const [config, setConfig] = useState<{
    gas: number;
    slippage: number;
  }>({
    gas: 1,
    slippage: 1
  });
  const [assetInfo, setAssetInfo] = useState(null);
  const [amount, setAmount] = useState(0);
  const [contractAddress, setContractAddress] = useState('');
  return <SnipeContext.Provider value={{
    assetInfo,
    setAssetInfo,
    contractAddress,
    setContractAddress,
    config,
    setConfig,
    activeTab,
    setActiveTab,
    amount,
    setAmount
  }} data-sentry-element="unknown" data-sentry-component="SnipeProvider" data-sentry-source-file="SnipeProvider.tsx">
      {children}
    </SnipeContext.Provider>;
};
export const useSnipe = () => {
  const snipeValues = useContext(SnipeContext);
  return snipeValues;
};